'use client';

import { Search } from '@/assets/Search';
import { useLayout } from '@/context/layout-context';
import * as Layout from '@/layout';

export default function NotFoundPage() {
  const { content } = useLayout();

  const { error: errorContent } = content || {};

  const { genericMessage = '', messagesByStatusCode = [] } = errorContent || {};

  const messageByStatus = messagesByStatusCode.find(
    ({ statusCode }) => statusCode === '404',
  );

  const message = messageByStatus?.message || genericMessage;

  return (
    <Layout.Root>
      <Layout.Navigation.Desktop.Root>
        <Layout.Navigation.Desktop.Header>
          <Layout.Navigation.Desktop.Logo />
          <Layout.Navigation.Desktop.Menu />
        </Layout.Navigation.Desktop.Header>
      </Layout.Navigation.Desktop.Root>

      <Layout.Navigation.Mobile.Logo />

      <Layout.Main>
        <Layout.Section isFullHeight className="py-0">
          <Layout.SectionContent className="items-center justify-center py-0">
            <div className="flex max-w-[37.5rem] flex-col items-center space-y-10">
              <h1 className="text-[8rem] font-bold">404</h1>

              <Search />

              <p className="text-center">{message}</p>
            </div>
          </Layout.SectionContent>
        </Layout.Section>
      </Layout.Main>

      <Layout.Navigation.Mobile.Root>
        <Layout.Navigation.Mobile.Menu />
      </Layout.Navigation.Mobile.Root>

      <Layout.Footer.Root>
        <Layout.Footer.Content>
          <Layout.Footer.HelpfulLinks />

          <Layout.Footer.Divider />

          <Layout.Footer.ZmyleInfo />
        </Layout.Footer.Content>
      </Layout.Footer.Root>
    </Layout.Root>
  );
}
